import instObj from '@/backend/axios-instances'

const resource = "/orders"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    // need supplier_id as a param
    return instance.post(resource, data, { params: parameters });
  },
  getByProduct(parameters) {
    return instance.get(`${resource}/byproduct`, { params: parameters });
  }
}
